var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUkFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_1749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.847656 0.277344V13.4206H26.4498V0.277344H-0.847656Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.847656 0.277344L26.4498 13.4206L-0.847656 0.277344ZM26.4498 0.277344L-0.847656 13.4194L26.4498 0.277344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8405 14.5961L12.8017 8.31757L-0.237031 14.5961L-1.45703 12.2429L9.74922 6.84785L-1.45703 1.45285L-0.237031 -0.900391L12.8017 5.37813L25.8405 -0.900391L27.0605 1.45285L15.8542 6.84785L27.0605 12.2429L25.8405 14.5961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.847656 0.277344L26.4498 13.4206L-0.847656 0.277344ZM26.4498 0.277344L-0.847656 13.4194L26.4498 0.277344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0416 14.2034L12.8004 7.82614L-0.440859 14.2034L-1.25586 12.6349L10.7666 6.84753L-1.25586 1.06012L-0.440859 -0.508301L12.8004 5.86892L26.0416 -0.508301L26.8566 1.06012L14.8341 6.84753L26.8566 12.6349L26.0416 14.2034Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8011 0.277344V13.4206V0.277344ZM-0.847656 6.84836H26.4498H-0.847656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0761 13.4194H10.5261V9.0391H-0.847656V4.65762H10.5261V0.277344H15.0761V4.65762H26.4498V9.0391H15.0761V13.4194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8011 0.277344V13.4206V0.277344ZM-0.847656 6.84836H26.4498H-0.847656Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1661 13.4194H11.4361V8.16281H-0.847656V5.53392H11.4361V0.277344H14.1661V5.53392H26.4498V8.16281H14.1661V13.4194Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_1749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 13,
    fill: "white",
    transform: "translate(0.800781 0.3479)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/UK_flag.af96ba726a65d58e676aa554e64e0b2e.svg";
export { ForwardRef as ReactComponent };